export { default } from './share-record-dialog'
